import { Input, Card, Typography, Form, Spin, message } from "antd"
import React, { useEffect, useState } from "react"
import { emails } from "../data"
import { Link } from "gatsby"
import { ArrowDownOutlined } from "@ant-design/icons"
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

const axios = require("axios")

const url = "https://staging.visiomate.com/crmPipeline"

const SideForm = ({ isDemo, link, credentials, setIsDemoAllow, isDemoAllow }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [isVerified, setIsVerified] = useState(false);
  const { TextArea } = Input
  const { Title } = Typography
  const [isHovered, setIsHovered] = useState(false)
  useEffect(() => {
    const getToken = async () => {
      if (!executeRecaptcha) return;
      const token = await executeRecaptcha("job_application");
      // Verify with server
      const res = await fetch("https://staging.visiomate.com/verify-recaptcha-site", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token }),
      });

      const data = await res.json();
      setIsVerified(data.success && data.score > 0.5);
      // setIsVerified(data.success);
    }
    getToken();
  }, [executeRecaptcha])
  let loadSpin = false
  const loadingSpinner = () => {
    loadSpin = true
    return ""
  }
  const handleHover = () => {
    setIsHovered(!isHovered)
  }
  const handleFormData = async values => {
    const { name, email, phone, message, designation, company, file } = values
    const formData = {
      name: "Proposal Request: " + name,
      partner_name: company,
      email_from: email,
      phone,
      mobile: phone,
      description: message,
      attachment_base64: "",
      email_to: emails.info,
    }
    sendFormData(formData, setLoading, url)
  }
  const sendFormData = async data => {
    try {
      setLoading(true)
      const response = await axios.post(
        "https://staging.visiomate.com/crmPipeline",
        data
      )
      setLoading(false)
      form.resetFields()
      if (isDemo) {
        setIsDemoAllow(true)
        return
      }
      message.success("Application submitted successfully!")
    } catch (error) {
      console.error("Error:", error)
      message.error("Failed to submit application. Please try again later.")
    } finally {
      setLoading(false)
    }
  }
  const onFinish = values => {
    handleFormData(values)
  }
  return (
    <Card className={isDemo ? "modal-form-data" : ""}>
      <Title level={3} className={isDemo ? "text-bottom-margin" : ""}>{isDemo ? "GET ACCESS TO THE DEMO" : "Request for proposal"}</Title>
      <Form
        form={form}
        name="about"
        wrapperCol={{
          span: 24,
        }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label=""
          name="name"
          rules={[
            !isDemo && {
              required: true,
              message: "Please input your Name!",
            },
          ]}
        >
          <Input placeholder={`Name${!isDemo ? "" : "(Optional)"}`} />
        </Form.Item>
        <Form.Item
          label=""
          name="email"
          rules={[
            {
              required: true,
              message: "Please enter your email address",
            },
            {
              type: "email",
              message: "Please enter a valid email address",
            },
          ]}
        >
          <Input placeholder="Email" type="email" style={{ margin: 0 }} />
        </Form.Item>

        {!isDemo && <Form.Item label="" name="company">
          <Input placeholder="Company" />
        </Form.Item>}
        {!isDemo && <Form.Item label="" name="message" rules="">
          <TextArea
            placeholder="Message"
            maxLength={100}
            autoSize={{ minRows: 2, maxRows: 2 }}
            style={{ margin: 0 }}
          />
        </Form.Item>}
        {isDemoAllow &&
          <div className="demo-data-credential-div">
            {credentials &&
              <div className="demo-data-credential">
                {
                  Array.isArray(credentials) ? credentials.map((credentialData, index) =>
                    <div key={index}>
                      {credentialData.type && <p><strong>Type:</strong> {credentialData.type}</p>}
                      <p><strong>{credentialData.username.includes('@') && credentialData.username.includes('.') ? 'Email' : 'Username'}:</strong> {credentialData.username}</p>
                      {credentialData.password && <p><strong>Password:</strong> {credentialData.password}</p>}
                      {credentialData.otp && <p><strong>OTP:</strong> {credentialData.otp}</p>}
                    </div>) : <>
                    <p><strong>{credentials.username.includes('@') && credentials.username.includes('.') ? 'Email' : 'Username'}:</strong> {credentials.username}</p>
                    {credentials.password && <p><strong>Password:</strong> {credentials.password}</p>}
                    {credentials.otp && <p><strong>OTP:</strong> {credentials.otp}</p>}
                  </>
                }

              </div>
            }
          </div>
        }
        <span className="proposal-submit">
          <a
            href={isDemoAllow ? link : "#"}
            style={{ "--yellow-color": isDemoAllow ? "#F0CD17" : "" }}
            buttonText={isDemoAllow ? "Continue to the Demo" : "Submit"}
            target="_blank"
            rel="noreferrer"
            disabled={loading || !isVerified}
            onClick={e => {
              !isDemoAllow && e.preventDefault()
              if (!isVerified) {
                return
              }
              !isDemoAllow && form.submit()
            }}
            onMouseEnter={handleHover}
            onMouseLeave={handleHover}
            data-front={
              loading ? loadingSpinner() : isHovered ? "Submit" : "Submit"
            }
            data-back={
              loading ? loadingSpinner() : isHovered ? "Submit" : "Submit"
            }
          />
          {loadSpin ? <Spin className="spinner-for-proposal-form" /> : ""}
        </span>
      </Form>
    </Card>
  )
}

export default SideForm
